import Get from './get'
import Post from './post'
import {demandLink , dojoLink , allLink , detailLink , contactLink , courseLink , signLink} from './config'

// link courses

const getDemand = () => Get(demandLink)

const getDojoProgram = () => Get(dojoLink)

const getAll = () => Get(allLink)

const getDetail = (id) => Get(`${detailLink}/${id}`)

const getCourse = () => Get(courseLink)

// contact link

const contactUs = (data) =>  Post(contactLink , data)

const signCourse = (data) => Post(signLink , data)

export {getDemand , getDojoProgram , getAll , getDetail , contactUs , getCourse , signCourse}